import { render, staticRenderFns } from "./dnd-list.vue?vue&type=template&id=2b1df54c&"
import script from "./dnd-list.vue?vue&type=script&lang=js&"
export * from "./dnd-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports